/* eslint id-length: "off", no-process-env: "off" */
import stub96 from "@/assets/img/stub96.png";
import stub192 from "@/assets/img/stub192.png";
import stub384 from "@/assets/img/stub384.png";
import stub1000 from "@/assets/img/stub1000.png";
import {SELF_BASE} from "@/lib/api";
import {DEFAULT_IMAGE_QUALITY} from "@/lib/graphics";

export const FORMAT_MIMES = {
  opus: "audio/ogg",
  mp3: "audio/mpeg",
};

export const COVER_SIZES = {
  low: 96,
  preview: 192,
  high: 1000,
  single: 128,
  multiList: 48,
  multiMobile: 96,
  multiDesktop: 220,
  card: 192,
};

export const COVER_STUBS = {
  96: stub96,
  192: stub192,
  384: stub384,
  1000: stub1000,
};

export const MUSIC_TYPES = {
  song: "Song",
  single: "Single",
  ep: "EP",
  album: "Album",
  comp: "Compilation",
  ost: "Soundtrack",
};

// Old way: const API_PREFIX = `${SELF_BASE}/api`;
const API_PREFIX = "/api";
const IMAGE_API_PREFIX = `${SELF_BASE}/api`;

export const makeCoverURI = (coverId, size = "128") =>
  `${IMAGE_API_PREFIX}/coverart/${coverId}/${size}`;
export const getCoverURI = (coverId, size) => {
  const finSize = Math.min(
    Math.max(size ?? COVER_SIZES.low, COVER_SIZES.low),
    COVER_SIZES.high
  );
  if (coverId === null) {
    return COVER_STUBS[finSize];
  }
  return makeCoverURI(coverId, finSize);
};

export const getAlbumURI = albumId => `${API_PREFIX}/album/${albumId}`;
export const getSongURI = songId => `${API_PREFIX}/song/${songId}`;
export const getStreamURI = (songId, format = "opus") =>
  `${API_PREFIX}/stream/${songId}/${format}`;

export const previewCoverLoader = ({src, width, quality}) =>
  `/_next/image?url=${getCoverURI(src, width)}&w=${width}&q=${quality || DEFAULT_IMAGE_QUALITY}`;

export const playerColumnClass = isMulti => (isMulti ? "column is-half-desktop is-full-touch" : "column");
